var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		_vm.$style['app-modal'],
		{
			[_vm.$style['app-modal--opened']]: _vm.isOpen,
			[_vm.$style['app-modal--closed']]: _vm.isClosed,
			[_vm.$style['app-modal--fixed']]: _vm.fixed
		}
	]},[_c('div',{ref:"content",class:[
			_vm.$style['app-modal__content'],
			{
				[_vm.$style['app-modal__content--animated']]: _vm.isAnimated
			}
		]},[_c('Surface',{directives:[{name:"testid",rawName:"v-testid",value:('app-modal'),expression:"'app-modal'"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.shake),expression:"shake"}],ref:"surface",class:[
				_vm.$style['app-modal__surface'],
				{ [_vm.$style['app-modal__surface--ai-loading']]: _vm.aiLoading }
			],style:({ maxWidth: _vm.width, minWidth: _vm.minWidth })},[(!_vm.prompt)?_c('BaseIconButton',{class:_vm.$style['app-modal__back'],nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'times']}})],1):_vm._e(),_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }